import { Typography } from "@circle-react-shared/uikit/Typography";
import {
  dateFormats,
  formattedDateTime,
} from "@circle-react/helpers/dateTimeHelpers/formattedDateTime";
import { formatPaywallCurrencyAmount } from "@circle-react/helpers/paywalls/currencies";

import { t } from "@/i18n-js/instance";

import { useCheckoutSession } from "../../../../Checkout/contexts/CheckoutSessionContext";
import {
  getMainStep,
  getPaywallPriceFromRecord,
  getResultingPurchaseFromStepSession,
  returnCreatedAtDateFromRecord,
} from "../../../helpers/SessionStepQueryHelper";

export const SummaryPrice = () => {
  const { session } = useCheckoutSession();

  const mainStep = getMainStep(session?.steps || []);
  const record = getResultingPurchaseFromStepSession(mainStep);
  const paywallPrice = getPaywallPriceFromRecord(record);
  const currency = paywallPrice?.currency;
  const totalAmountPaid = session?.total_amount_paid;
  const createdAt = returnCreatedAtDateFromRecord(record);

  if (!session) {
    return null;
  }

  return (
    <div className="flex flex-col gap-y-2">
      <div className="flex flex-row justify-between">
        <div className="flex flex-row">
          <Typography.LabelMd weight="semibold" color="text-primary">
            {t("paid_on", {
              date: formattedDateTime({
                dateTime: createdAt,
                format: dateFormats.short_weekday_short_month,
              }),
            })}
          </Typography.LabelMd>
        </div>
        {currency && totalAmountPaid != null && (
          <Typography.LabelMd weight="semibold">
            {formatPaywallCurrencyAmount(currency, totalAmountPaid)}
          </Typography.LabelMd>
        )}
      </div>
    </div>
  );
};
